<div class="main-survey-header">
  <!-- Survey Header for Mobile -->

  <div class="header-for-mobile">
    <header class="mobile-app-bar">
      <h4 (click)="closeSheet()" translate>Cancel</h4>
      <div>
        <p class="survey-heading-for-mobile">{{ formSurveyId ? ('Survey Edit' | translate) : ('New Survey' | translate) }}</p>
      </div>
      <h4 (click)="save()" translate>Save</h4>
    </header>
    <div class="ruler-1"></div>
  </div>

  <!-- Survey Header for web -->
  <div class="header-for-web">
    <header class="mobile-app-bar">
      <h4>{{ formSurveyId ? ('Survey Edit' | translate) : ('New Survey' | translate) }}</h4>
      <div class="mobile-app-bar__action-icons-group">
        <app-icon (click)="closeDialogBox()" [ngStyle]="{ cursor: 'pointer' }" [planeIcon]="true" color="var(--text-color-medium)" iconName="close" size="20px"></app-icon>
      </div>
    </header>
  </div>
</div>
<!-- Survey Body -->
<div class="main-container">
  <form [formGroup]="form">
    <!-- Image Selector -->
    <div class="input-group">
      <label for="image" translate>Image</label>
      <app-image-selector
        (imageSelected)="selectedImage = $event"
        [aspectRatio]="4 / 3"
        [entityId]="formSurveyId"
        [fullWidthPreview]="true"
        [imageCropper]="true"
        [isUpdateMode]="isUpdateMode"
        [sectionType]="SectionType.SURVEY"
        [selectedImageUrl]="currentSurvey?.imageUrl?.toString() || null"
        formControlName="image"
        id="image"
        name="image"
      ></app-image-selector>
      <!--            <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
    </div>

    <!--  Title  -->

    <div class="input-group --required">
      <label for="surveyTitle" translate>Title</label>
      <input [placeholder]="'Enter your survey name' | translate" formControlName="title" id="surveyTitle" name="surveyTitle" type="text" />
      <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
    </div>

    <!-- Description -->

    <div class="input-group --required">
      <label for="description" translate>Description</label>
      <textarea [placeholder]="'Enter your survey description' | translate" formControlName="description" id="description" name="description" type="text"></textarea>
      <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
    </div>

    <div class="flex-row-between-center gap-12">
      <!--  Start date  -->
      <div class="input-group input-full-width --required">
        <label for="startDate" translate>Start Date</label>
        <app-date-picker-input [pastDatesSelection]="false" formControlName="startDate" id="startDate" name="startDate"></app-date-picker-input>
        <app-form-error [control]="form.get('startDate')" [name]="'Start Date' | translate"></app-form-error>
      </div>

      <!--  End date  -->

      <div class="input-group input-full-width --required">
        <label for="endDate" translate>End Date</label>
        <app-date-picker-input [pastDatesSelection]="false" [preSelectedDate]="form.get('startDate').value" formControlName="endDate" id="endDate" name="endDate"></app-date-picker-input>
        <app-form-error [control]="form.get('endDate')" [name]="'End Date' | translate"></app-form-error>
      </div>
    </div>

    <!--  Answer Options  -->

    <div class="survey-card">
      <div class="survey-card__header">
        <h5 translate>Answer Options</h5>
      </div>
      <div class="survey-card__body">
        <div class="input-group">
          <div class="radio-groups-container">
            @for (option of surveyOptions; track option) {
              <div class="radio-group">
                <input [id]="option.key" [value]="option.value" class="radio" formControlName="option" name="option" type="radio" />
                <label [for]="option.key" translate>{{ option.key }}</label>
              </div>
            }
          </div>
          <app-form-error [control]="form.get('option')" [name]="'Option'"></app-form-error>
        </div>

        <!-- Choices Answers input -->
        <!-- Dynamic Answers Inputs -->
        <div formArrayName="answers">
          @for (answer of answers.controls; track answer; let i = $index) {
            <div class="input-group input-icon-postfix --required">
              <input [formControlName]="i" [placeholder]="'Enter answer choice' | translate" type="text" />
              @if (i > 1) {
                <app-icon (click)="removeAnswer(i)" [cssStyle]="{ cursor: 'pointer' }" [planeIcon]="true" color="var(--text-color-medium)" iconName="close" size="16px"></app-icon>
              }
              <app-form-error [control]="answers.controls[i]" [name]="'Answer' | translate"></app-form-error>
            </div>
          }
        </div>

        <!-- Add Button -->
        <div class="survey-card__body__button">
          <button (click)="addAnswer()" class="button button-medium button-full button-simple" translate type="button"><app-icon iconName="add" size="16px"></app-icon>&nbsp;&nbsp; Add Choice</button>
        </div>
      </div>
    </div>

    <!--  Tags  -->
    <div class="input-group">
      <label for="description" translate>Tags</label>
      <ng-select
        [addTag]="addTagFn"
        [items]="tags"
        [multiple]="true"
        [notFoundText]="'No tags available' | translate"
        [placeholder]="'Enter to search' | translate"
        [selectOnTab]="true"
        bindLabel="tagName"
        bindValue="tagName"
        class="custom"
        formControlName="tags"
        searchable="true"
      ></ng-select>
    </div>

    <div class="survey-input-row flex-row-between-center gap-12">
      <!--   Type   -->

      <div class="input-group input-full-width --required">
        <label for="type" translate>Type</label>
        <app-dropdown [options]="surveyTypes" bindValue="value" displayName="key" formControlName="type" id="type"></app-dropdown>
        <app-form-error [control]="form.get('type')" [name]="'Survey Type' | translate"></app-form-error>
      </div>

      <!--   Group Type   -->

      @if (form.get('type').value === SurveyType.Group) {
        <div class="input-group input-full-width --required">
          <label for="groupType" translate>Group</label>
          <app-dropdown [options]="groups" bindValue="id" displayName="name" formControlName="groupType" id="groupType"></app-dropdown>
          <app-form-error [control]="form.get('groupType')" [name]="'Group' | translate"></app-form-error>
        </div>
      }
    </div>

    <div class="input-group input-full-width --required">
      <label for="viewOption" translate>View Options</label>
      <app-dropdown [options]="surveyViewOptions" bindValue="value" displayName="key" formControlName="viewOption" id="viewOption"></app-dropdown>
      <app-form-error [control]="form.get('viewOption')" [name]="'View Options' | translate"></app-form-error>
    </div>

    <!--   Notification   -->
    <!-- TODO: COMMENTED out because this dropdown is not required for now as per request -->

    <!--      <div class="input-group input-full-width &#45;&#45;required">-->
    <!--        <label for="notificationOption" translate>Notification</label>-->
    <!--        <app-dropdown [options]="surveyNotificationOptions" bindValue="value" displayName="key" formControlName="notificationOption" id="notificationOption"></app-dropdown>-->
    <!--        <app-form-error [control]="form.get('notificationOption')" [name]="'Notification' | translate"></app-form-error>-->
    <!--      </div>-->

    <!--  Anonymous Voting  -->

    <div class="input-group">
      <label for="additionalAnonymousVoting" translate>Anonymous Voting</label>
      <input class="toggle-btn" formControlName="additionalAnonymousVoting" id="additionalAnonymousVoting" name="additionalAnonymousVoting" type="checkbox" />
    </div>

    <!--  Allow Casted voted to be correct  -->

    <div class="input-group">
      <label for="additionalCastVote" translate>Allow Correcting the Cast Vote</label>
      <input class="toggle-btn" formControlName="additionalCastVote" id="additionalCastVote" name="additionalAnonymousVoting" type="checkbox" />
    </div>

    <!--    <div class="mt-20">-->
    <!--      <button class="button button-full button-simple" translate type="button">-->
    <!--        <app-icon iconName="add" size="16px"></app-icon>&nbsp;&nbsp; Add Question-->
    <!--      </button>-->
    <!--    </div>-->

    <div class="buttons-container showOnDesktop">
      <button (click)="closeDialogBox()" class="button button-simple button-hidden" translate>Cancel</button>
      <app-button
        (clickEvent)="submit($event)"
        [disabled]="form.pristine"
        [idleText]="(currentSurvey && currentSurvey.id ? 'Update' : 'Save') | translate"
        cssClass="button button-primary"
        translate
        type="submit"
      ></app-button>
    </div>

    <div class="showOnMobile mt-50">
      <app-button
        (clickEvent)="submit($event)"
        [disabled]="form.pristine"
        [idleText]="(currentSurvey && currentSurvey.id ? 'Update' : 'Save') | translate"
        [style]="{ width: '100%' }"
        cssClass="button-primary button-full"
        translate
        type="submit"
      ></app-button>
    </div>
  </form>
</div>
